import * as React from "react";
export var Error = function Error(_ref) {
  var error = _ref.error;
  return React.createElement(React.Fragment, null, error);
};
export default Error;